// 其他信息
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default (state) => {
  let other = get(state, 'currentShopBaseDetail.officialUrl', {})
  return {
    title: i18n.gettext('商户官网'),
    content: [
      {
        title: i18n.gettext('商户官网'),
        label: other.officialUrl
      }
    ]
  }
}
